import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { LinkCardComponent } from './shared/components/link-card/link-card.component';
import { BannerComponent } from './shared/components/banner/banner.component';
import { ContactCardComponent } from './shared/components/contact-card/contact-card.component';
import { NewestAssetCardComponent } from './shared/components/newest-asset-card/newest-asset-card.component';
import { FilterComponent } from './shared/components/filter/filter.component';
import { AssetCardComponent } from './shared/components/asset-card/asset-card.component';
import { AssetsComponent } from './components/assets/assets.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerFeaturesComponent } from './shared/components/banner-features/banner-features.component';
import { AssetDetailsComponent } from './components/asset-details/asset-details.component';
import { FaqComponent } from './components/faq/faq.component';
import { CollapseCardComponent } from './shared/components/collapse-card/collapse-card.component';
import { RatingModalComponent } from './shared/components/rating-modal/rating-modal.component';
// import { HighlightPipe } from './shared/pipe/highlight.pipe';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
// import { LoadingSpinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';
import { OverviewComponent } from './shared/components/overview/overview.component';
import { ContributorsComponent } from './shared/components/contributors/contributors.component';
import { AssetReviewsComponent } from './shared/components/asset-reviews/asset-reviews.component';
import { StarRatingComponent } from './shared/components/star-rating/star-rating.component';
import { ResourcesLinksComponent } from './shared/components/resources-links/resources-links.component';
import { RequestAccessModalComponent } from './shared/components/request-access-modal/request-access-modal.component';
import { MyBookmarksComponent } from './components/my-bookmarks/my-bookmarks.component';
// import { NgxPageScrollCoreModule, PageScrollService } from 'ngx-page-scroll-core';
import { ScrollDetectSpyDirective } from './shared/directives/scroll-detect-spy.directive';
// import { BasicDialogComponent } from './shared/dialog/dialog.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from "src/environments/environment.demo";
import { SharedModule } from './shared.module'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {

}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId, // This is your client ID
      authority: environment.authority, // This is your tenant ID
      redirectUri: environment.redirectUri// This is your redirect URI
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('Enter_the_Graph_Endpoint_Herev1.0/me', ['user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read'],
      // prompt: "select_account"
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LinkCardComponent,
    BannerComponent,
    ContactCardComponent,
    NewestAssetCardComponent,
    FilterComponent,
    AssetCardComponent,
    AssetsComponent,
    BannerFeaturesComponent,
    AssetDetailsComponent,
    FaqComponent,
    CollapseCardComponent,
    // LoadingSpinnerComponent,
    RatingModalComponent,
    // HighlightPipe,
    OverviewComponent,
    ContributorsComponent,
    AssetReviewsComponent,
    StarRatingComponent,
    ResourcesLinksComponent,
    RequestAccessModalComponent,
    MyBookmarksComponent,
    ScrollDetectSpyDirective,
    //BasicDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2SearchPipeModule,
    HttpClientModule,
    // NgxPageScrollCoreModule.forRoot({ duration: 400, scrollOffset: 80 }),
    MsalModule,
    SharedModule,
    BrowserAnimationsModule,
  ],
  exports: [
    // LoadingSpinnerComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    // PageScrollService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
